import { getRequest } from "../../shared/api/axiosHandler";
import { featuredCollectionId } from "../../shared/utils/constants";

export const getBanners = async () => {
  try {
    return await getRequest('/public/banners');
  } catch (error) {
    throw error;
  }
}

export const fetchTopSellingProducts = async () => {
  try {
    return await getRequest('/public/products/top-selling');
  } catch (error) {
    throw error;
  }
}

export const fetchFeatured999 = async (page = 0, size = 30) => {
  try {
    const response = await getRequest(`/public/collections/id/${featuredCollectionId}?page=${page}&size=${size}`);
    return response;
  } catch (error) {
    throw error;
  }
};
